export default __webpack_public_path__ + "static/media/a017-market-3.4839afe1.svg";